import { styled } from "@mui/system";
import { Box, Button } from "@mui/material";

export const ShiftRequestContainer = styled(Box)({
  width: "100%",
  padding: "15px 40px",
});

export const Card = styled(Box)({
  backgroundColor: "#7878805C",
  borderRadius: "28px",
  padding: "16px",
  boxSizing: "border-box",
  width: "100%",
  minHeight: "150px",
  display: "flex",
  flexDirection: "column",
  justifyContent: "space-between",
});

export const ArrowContainer = styled(Box, {
  shouldForwardProp: (prop) => prop !== "position",
})(({ position }) => ({
  position: "absolute",
  padding: "72px 7px",
  height: "100%",
  top: "50%",
  transform: "translateY(-50%)",
  zIndex: 2,
  cursor: "pointer",
  backgroundColor: "#7676803D",
  borderRadius: "28px",
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  ...(position === "right"
    ? {
        right: "-46px",
      }
    : {
        left: "-46px",
      }),
}));

export const CarouselButton = styled(Button)({
  color: "#0A84FF",
  textTransform: "none",
  background: "none",
  fontWeight: "600",
});
